<template>
    <div>
        <!-- FASE 4 / BLOCO AA — DOC 1, 3, 5, 7, 10, 24, 26, 30, 35, 96 -->

        <el-row :gutter="10" class="u-mt-10 u-mb-10">
            <el-col :xs="24" :sm="10" :md="10">
                <!--
                    Ícone no SUFIXO, não no prefixo: `style.css` aplica
                    `padding: 0 !important` em todo `.el-input__inner`, então um ícone à
                    esquerda fica por cima do texto digitado e do placeholder.
                -->
                <el-input v-model="filtro.termo" placeholder="Buscar por título, conteúdo ou autor..."
                          @keyup.native.enter="carregar" clearable
                          suffix-icon="el-icon-search"></el-input>
            </el-col>
            <el-col :xs="12" :sm="4" :md="4">
                <el-date-picker v-model="filtro.de" type="date" placeholder="De"
                                value-format="yyyy-MM-dd" style="width:100%" @change="carregar"></el-date-picker>
            </el-col>
            <el-col :xs="12" :sm="4" :md="4">
                <el-date-picker v-model="filtro.ate" type="date" placeholder="Até"
                                value-format="yyyy-MM-dd" style="width:100%" @change="carregar"></el-date-picker>
            </el-col>
            <el-col :xs="12" :sm="3" :md="3">
                <el-select v-model="filtro.extensao" placeholder="Tipo" clearable style="width:100%" @change="carregar">
                    <el-option v-for="e in extensoes" :key="e" :label="e.toUpperCase()" :value="e"></el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="12" :sm="4" :md="4">
                <!-- DOC 35 — "filtrar por período, tipo, todos e status" -->
                <label class="rotulo-filtro">Situação</label>
                <el-select v-model="filtro.situacao" placeholder="Status" style="width:100%" @change="carregar">
                    <el-option label="Ativos"    value="ativo"></el-option>
                    <el-option label="Excluídos" value="excluido"></el-option>
                    <el-option label="Todos"     value="todos"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="12" :sm="4" :md="4">
                <!-- DOC 6 — "documentos adicionados pelo usuário, compartilhados com ele" -->
                <label class="rotulo-filtro">Meus e compartilhados comigo</label>
                <el-select v-model="filtro.compartilhados_comigo" style="width:100%"
                           @change="carregar">
                    <el-option label="Não" :value="false"></el-option>
                    <el-option label="Sim" :value="true"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="12" :sm="4" :md="4">
                <el-button type="text" icon="el-icon-refresh-left" @click="limparFiltros">Limpar filtros</el-button>
            </el-col>
            <el-col :xs="24" :sm="16" :md="16" class="u-text-right">
                <el-button-group>
                    <el-button :type="modo === 'lista' ? 'primary' : 'default'" icon="el-icon-s-unfold"
                               size="small" title="Lista" @click="definirModo('lista')"></el-button>
                    <el-button :type="modo === 'grade' ? 'primary' : 'default'" icon="el-icon-menu"
                               size="small" title="Grade" @click="definirModo('grade')"></el-button>
                </el-button-group>
            </el-col>
        </el-row>

        <el-row :gutter="10" class="u-mb-20">
            <el-col :xs="24" :sm="14" :md="14">
                <!-- A pasta em que estamos é o ÚLTIMO item: não é link, é o lugar atual. -->
                <nav class="caminho-atual">
                    <i class="el-icon-folder-opened caminho-icone"></i>
                    <a v-if="trilha.length" href="#" class="caminho-link"
                       @click.prevent="irParaPasta(null)">Raiz</a>
                    <span v-else class="caminho-aqui">Raiz</span>

                    <template v-for="(p, i) in trilha">
                        <i :key="'s'+i" class="el-icon-arrow-right caminho-sep"></i>
                        <a v-if="i < trilha.length - 1" :key="'a'+i" href="#" class="caminho-link"
                           @click.prevent="irParaPasta(p)">{{ p.nome }}</a>
                        <span v-else :key="'c'+i" class="caminho-aqui">{{ p.nome }}</span>
                    </template>
                </nav>
            </el-col>
            <el-col :xs="24" :sm="10" :md="10" class="u-text-right">
                <el-button type="default" icon="el-icon-folder-add" size="small"
                           @click="abrirNovaPasta">NOVA PASTA</el-button>
                <router-link to="/admin/documento/cadastro" class="btn-new-register u-ml-10">
                    <el-button type="primary" size="small">NOVO DOCUMENTO</el-button>
                </router-link>
            </el-col>
        </el-row>

        <!-- DOC 31 — envio de documentos EM LOTE para assinatura -->
        <el-row v-if="selecionados.length" class="u-mb-10 barra-lote">
            <el-col :xs="24">
                <strong>{{ selecionados.length }}</strong> documento(s) selecionado(s)
                <el-button type="primary" size="mini" icon="el-icon-s-check"
                           @click="dialogLote = true">ENVIAR PARA ASSINATURA</el-button>
                <el-button class="u-ml-10" type="text" size="mini" @click="selecionados = []">limpar seleção</el-button>
            </el-col>
        </el-row>

        <!--
            Perfil de rede não tem escola no header, então na Raiz o `instituicao_id` ia
            nulo e o `store` respondia 403 "Informe a instituição em que o documento será
            criado", sem lugar nenhum onde informá-la. Dentro de uma pasta não aparece:
            ali a instituição vem da própria pasta.
        -->
        <div v-if="ehRede && !pastaAtual" class="u-mb-10">
            <el-select v-model="instituicaoEnvio" filterable clearable size="small"
                       placeholder="Instituição dos arquivos enviados" style="width:100%">
                <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
            </el-select>
        </div>

        <!-- DOC 3, 26, 96: arrastar-e-soltar, múltiplos arquivos e pastas do explorador -->
        <el-upload
            class="area-arrastar u-mb-20"
            drag
            multiple
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="aoSoltarArquivos">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                Arraste arquivos aqui ou <em>clique para selecionar</em>
            </div>
            <div class="el-upload__tip" slot="tip">
                Vários arquivos de uma vez. Cada um vira um documento nesta pasta.
                <a href="#" @click.prevent="selecionarPasta">Enviar uma pasta inteira</a>.
            </div>
        </el-upload>
        <input ref="inputPasta" type="file" webkitdirectory directory multiple
               style="display:none" @change="aoSelecionarPasta" />

        <div class="container-table" v-loading="!statusList">

            <!-- DOC 30 — modo lista -->
            <table class="table table-striped" v-if="modo === 'lista'">
                <thead>
                    <tr>
                        <th style="width:34px" class="u-text-center">
                            <el-checkbox :value="todosSelecionados" @change="alternarTodos"></el-checkbox>
                        </th>
                        <th style="width:40px"></th>
                        <th>Nome</th>
                        <th class="hidden-mobile">Autor</th>
                        <th class="hidden-mobile u-text-center" style="width:110px">Atualizado</th>
                        <th class="u-text-center" style="width:200px">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="p in pastas" :key="'p'+p.id">
                        <td></td>
                        <td class="u-text-center"><i class="el-icon-folder" style="color:#E6A23C"></i></td>
                        <td><a href="#" @click.prevent="irParaPasta(p)">{{ p.nome }}</a></td>
                        <td class="hidden-mobile">—</td>
                        <td class="hidden-mobile u-text-center">{{ p.updated_at | formatarData }}</td>
                        <td class="u-text-center acao">
                            <el-button type="info" icon="el-icon-edit" size="mini" plain
                                       title="Renomear" @click="renomearPasta(p)"></el-button>
                            <el-button class="u-ml-10" type="success" icon="el-icon-share" size="mini" plain
                                       title="Compartilhar" @click="abrirCompartilhar('pasta', p)"></el-button>
                            <el-button class="u-ml-10" type="warning" icon="el-icon-rank" size="mini" plain
                                       title="Mover" @click="abrirMoverPasta(p)"></el-button>
                            <el-button class="u-ml-10" type="danger" icon="el-icon-delete" size="mini" plain
                                       title="Excluir" @click="excluirPasta(p)"></el-button>
                        </td>
                    </tr>
                    <tr v-for="d in items" :key="'d'+d.id">
                        <td class="u-text-center">
                            <el-checkbox v-if="!d.deleted_at" :value="selecionados.indexOf(d.id) >= 0"
                                         @change="alternarSelecao(d.id)"></el-checkbox>
                        </td>
                        <td class="u-text-center"><i class="el-icon-document" style="color:#409EFF"></i></td>
                        <td>
                            <router-link :to="'/admin/documento/detalhe/'+d.id">{{ d.titulo }}</router-link>
                            <div class="descricao-doc" v-if="d.descricao">{{ d.descricao | truncate(70, '...') }}</div>
                        </td>
                        <td class="hidden-mobile">{{ nomeAutor(d.user_id) }}</td>
                        <td class="hidden-mobile u-text-center">{{ d.updated_at | formatarData }}</td>
                        <td class="u-text-center acao">
                            <template v-if="!d.deleted_at">
                                <router-link :to="'/admin/documento/detalhe/'+d.id" class="link-icon u-mr-10">
                                    <el-button type="info" icon="el-icon-view" size="mini" plain title="Abrir"></el-button>
                                </router-link>
                                <!-- DOC 11, 33, 40 -->
                                <el-button type="success" icon="el-icon-share" size="mini" plain
                                           title="Compartilhar" @click="abrirCompartilhar('documento', d)"></el-button>
                                <el-button class="u-ml-10" type="warning" icon="el-icon-rank" size="mini" plain
                                           title="Mover" @click="abrirMoverDocumento(d)"></el-button>
                                <el-button class="u-ml-10" type="danger" icon="el-icon-delete" size="mini" plain
                                           title="Excluir" @click="excluirDocumento(d)"></el-button>
                            </template>
                            <el-tag v-else size="mini" type="danger">na lixeira</el-tag>
                        </td>
                    </tr>
                    <tr v-if="!pastas.length && !items.length && statusList">
                        <td colspan="6" class="u-text-center u-mt-25">Nenhum documento ou pasta aqui.</td>
                    </tr>
                </tbody>
            </table>

            <!-- DOC 30 — modo grade -->
            <el-row :gutter="10" v-if="modo === 'grade'">
                <el-col :xs="12" :sm="6" :md="4" v-for="p in pastas" :key="'gp'+p.id">
                    <div class="card-item" @click="irParaPasta(p)">
                        <i class="el-icon-folder card-icone" style="color:#E6A23C"></i>
                        <div class="card-nome">{{ p.nome }}</div>
                    </div>
                </el-col>
                <el-col :xs="12" :sm="6" :md="4" v-for="d in items" :key="'gd'+d.id">
                    <div class="card-item" @click="$router.push('/admin/documento/detalhe/'+d.id)">
                        <i class="el-icon-document card-icone" style="color:#409EFF"></i>
                        <div class="card-nome">{{ d.titulo }}</div>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} documentos.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                       @current-change="getPagePagination" :page-size="30" background
                                       layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- DOC 31 — lote -->
        <el-dialog title="Enviar documentos para assinatura" :visible.sync="dialogLote" width="560px">
            <p class="meta">
                Os {{ selecionados.length }} documentos selecionados irão para os mesmos
                assinantes. Documentos sem arquivo anexado ficam de fora, e a lista de
                exceções é mostrada ao final.
            </p>
            <el-form label-position="top">
                <el-form-item label="Natureza (opcional)">
                    <el-input v-model="lote.natureza" maxlength="60"></el-input>
                </el-form-item>
                <el-form-item label="Assinantes">
                    <el-select v-model="lote.assinantes" multiple filterable remote
                               :remote-method="buscarAssinantes" :loading="buscandoAssinante"
                               placeholder="Digite o nome" style="width:100%">
                        <el-option v-for="u in usuariosLote" :key="u.id" :label="u.name" :value="u.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogLote = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" :disabled="!lote.assinantes.length" @click="enviarLote">
                    ENVIAR
                </el-button>
            </span>
        </el-dialog>

        <!-- DOC 11, 33, 40 -->
        <compartilhamento :visivel="dialogCompartilhar" :tipo="alvoCompartilhar.tipo"
                          :alvoId="alvoCompartilhar.id" :nomeAlvo="alvoCompartilhar.nome"
                          :publico="alvoCompartilhar.publico"
                          @fechar="dialogCompartilhar = false" @atualizado="carregar">
        </compartilhamento>

        <!-- mover: destino -->
        <el-dialog title="Mover para" :visible.sync="dialogMover" width="440px">
            <el-select v-model="destinoId" placeholder="Escolha a pasta de destino" style="width:100%" clearable>
                <el-option label="/ (raiz)" :value="null"></el-option>
                <el-option v-for="p in pastasPlanas" :key="p.id" :label="p.caminho" :value="p.id"></el-option>
            </el-select>
            <span slot="footer">
                <el-button @click="dialogMover = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" @click="confirmarMover">MOVER</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import moment from 'moment'
import compartilhamento from '@/components/documento/compartilhamento/compartilhamento'

export default {
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '—' }
    },
    data: () => ({
        statusList: false,
        modo: 'lista',
        pastaAtual: null,
        trilha: [],
        arvore: [],
        pastasPlanas: [],
        pastas: [],
        items: [],
        autores: {},
        extensoes: ['pdf','doc','docx','odt','txt','xls','xlsx','ods','csv','ppt','pptx','jpg','png','zip','xml'],
        filtro: { termo: '', de: '', ate: '', extensao: '', situacao: 'ativo', compartilhados_comigo: false },
        selecionados: [],
        dialogLote: false,
        lote: { natureza: '', assinantes: [] },
        usuariosLote: [],
        buscandoAssinante: false,
        dialogCompartilhar: false,
        alvoCompartilhar: { tipo: 'documento', id: null, nome: '', publico: false },
        paginate: { page: 1, qtdItens: 0, from: '', to: '' },
        dialogMover: false,
        destinoId: null,
        movendo: null,
        instituicoes: [],
        instituicaoEnvio: null
    }),
    computed: {
        /** Perfis de abrangência de rede — os que não têm escola no contexto do header. */
        ehRede () {
            const t = parseInt(this.$store.state.user ? this.$store.state.user.tipo : null)
            return t === 10 || (t > 3 && t <= 8)
        },

        todosSelecionados () {
            const disponiveis = this.items.filter(d => !d.deleted_at)
            return disponiveis.length > 0 && this.selecionados.length === disponiveis.length
        }
    },
    mounted () {
        // DOC 30 — a preferência de exibição é por pessoa, não do sistema.
        try {
            const salvo = window.localStorage.getItem('documento_modo')
            if (salvo === 'grade' || salvo === 'lista') this.modo = salvo
        } catch (e) { /* navegador sem storage: fica no padrão */ }

        if (this.ehRede) this.carregarInstituicoes()
        this.carregarArvore()
        this.carregar()
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        carregarInstituicoes () {
            this.$axios.get(`${this.base()}/api/instituicao/getAll`, this.auth())
                .then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : Object.values(r.data || {}) })
                .catch(() => { this.instituicoes = [] })
        },

        instituicaoAtual () {
            if (this.ehRede) return this.instituicaoEnvio
            const i = this.$store.state.config.instituicao
            return i ? i.id : null
        },

        /**
         * Mostra a recusa ao usuário.
         *
         * `throwException` do store só faz `console.log`, então uma negativa de permissão
         * ficaria invisível na tela — o usuário clicaria e nada aconteceria. Aqui a mensagem
         * que o backend devolveu é exibida.
         */
        erro (e) {
            window.eventBus.$emit('loading', false)
            const resp = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (resp && typeof resp.erro === 'string') msg = resp.erro
            else if (resp && resp.erro && resp.erro.text) msg = resp.erro.text
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        definirModo (m) {
            this.modo = m
            try { window.localStorage.setItem('documento_modo', m) } catch (e) { /* ignora */ }
        },

        carregarArvore () {
            this.$axios.post(`${this.base()}/api/documento-pasta/arvore`, {}, this.auth()).then(r => {
                this.arvore = r.data
                this.pastasPlanas = this.achatar(r.data)
                this.filtrarPastasDoNivel()
            }).catch(e => { this.erro(e) })
        },

        achatar (nos, acc) {
            acc = acc || []
            nos.forEach(n => {
                acc.push(n)
                if (n.filhas && n.filhas.length) this.achatar(n.filhas, acc)
            })
            return acc
        },

        filtrarPastasDoNivel () {
            const paiId = this.pastaAtual ? this.pastaAtual.id : null
            this.pastas = this.pastasPlanas.filter(p => {
                const pai = p.pasta_pai_id === undefined ? null : p.pasta_pai_id
                return (pai === null ? null : Number(pai)) === (paiId === null ? null : Number(paiId))
            })
        },

        carregar () {
            this.statusList = false
            this.items = []

            const payload = Object.assign({}, this.filtro, {
                pasta_id: this.pastaAtual ? this.pastaAtual.id : 'raiz'
            })

            // Numa busca por termo, procura na instituição inteira — não só na pasta aberta.
            if (this.filtro.termo) delete payload.pasta_id

            this.$axios.post(`${this.base()}/api/documento/getAllPaginate?page=${this.paginate.page}`,
                payload, this.auth()).then(r => {
                this.items = r.data.data
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
                this.carregarAutores()
            }).catch(e => { this.statusList = true; this.erro(e) })
        },

        carregarAutores () {
            // O backend não devolve dado pessoal do autor na listagem (LGPD): só o id.
            // O nome vem do próprio usuário logado quando for ele; senão fica o rótulo neutro.
            const eu = this.$store.state.user
            if (eu && eu.id) this.$set(this.autores, eu.id, eu.name)
        },

        nomeAutor (id) {
            const eu = this.$store.state.user
            if (eu && Number(eu.id) === Number(id)) return 'Você'
            return this.autores[id] || '—'
        },

        irParaPasta (pasta) {
            this.pastaAtual = pasta
            this.paginate.page = 1

            if (!pasta) {
                this.trilha = []
            } else {
                const idx = this.trilha.findIndex(p => Number(p.id) === Number(pasta.id))
                if (idx >= 0) this.trilha = this.trilha.slice(0, idx + 1)
                else this.trilha.push(pasta)
            }

            this.filtrarPastasDoNivel()
            this.carregar()
        },

        abrirNovaPasta () {
            this.$prompt('Nome da nova pasta', 'Nova pasta', {
                confirmButtonText: 'Criar', cancelButtonText: 'Cancelar'
            }).then(({ value }) => {
                if (!value || !value.trim()) return

                const payload = { nome: value.trim() }
                if (this.pastaAtual) payload.pasta_pai_id = this.pastaAtual.id
                else payload.instituicao_id = this.instituicaoAtual()

                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/documento-pasta/store`, payload, this.auth()).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Pasta criada.', type: 'success' })
                    this.carregarArvore()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        renomearPasta (p) {
            this.$prompt('Novo nome', 'Renomear pasta', {
                confirmButtonText: 'Salvar', cancelButtonText: 'Cancelar', inputValue: p.nome
            }).then(({ value }) => {
                if (!value || !value.trim()) return
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/documento-pasta/update/${p.id}`,
                    { nome: value.trim() }, this.auth()).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Pasta renomeada.', type: 'success' })
                    this.carregarArvore()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        excluirPasta (p) {
            this.$msgbox.confirm(
                'A pasta e tudo que está dentro dela vão para a lixeira. Continuar?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/documento-pasta/remover/${p.id}`, this.auth()).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Enviado para a lixeira.', type: 'success' })
                    this.carregarArvore(); this.carregar()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        excluirDocumento (d) {
            this.$msgbox.confirm('Enviar este documento para a lixeira?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/documento/remover/${d.id}`, this.auth()).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Enviado para a lixeira.', type: 'success' })
                    this.carregar()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        abrirMoverPasta (p)      { this.movendo = { tipo: 'pasta', item: p }; this.destinoId = null; this.dialogMover = true },
        abrirMoverDocumento (d)  { this.movendo = { tipo: 'doc',   item: d }; this.destinoId = null; this.dialogMover = true },

        confirmarMover () {
            if (!this.movendo) return

            const url = this.movendo.tipo === 'pasta'
                ? `${this.base()}/api/documento-pasta/mover/${this.movendo.item.id}`
                : `${this.base()}/api/documento/mover/${this.movendo.item.id}`

            const payload = this.movendo.tipo === 'pasta'
                ? { pasta_pai_id: this.destinoId }
                : { pasta_id: this.destinoId }

            window.eventBus.$emit('loading', true)
            this.$axios.post(url, payload, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Item movido.', type: 'success' })
                this.dialogMover = false
                this.carregarArvore(); this.carregar()
            }).catch(e => { this.erro(e) })
        },

        // DOC 3, 26 — arrastar e soltar vários de uma vez.
        aoSoltarArquivos (file) {
            this.criarDocumentoComArquivo(file.raw, file.name)
        },

        selecionarPasta () { this.$refs.inputPasta.click() },

        // DOC 96 — pasta do explorador, em massa, em ordem alfabética.
        aoSelecionarPasta (ev) {
            const arquivos = Array.from(ev.target.files || [])
            if (!arquivos.length) return

            arquivos.sort((a, b) => {
                const ca = a.webkitRelativePath || a.name
                const cb = b.webkitRelativePath || b.name
                return ca.localeCompare(cb, 'pt-BR')
            })

            this.$msgbox.confirm(
                `Enviar ${arquivos.length} arquivo(s) desta pasta? Cada arquivo vira um documento.`,
                'Enviar pasta', { confirmButtonText: 'Enviar', cancelButtonText: 'Cancelar' }
            ).then(() => {
                arquivos.forEach(f => this.criarDocumentoComArquivo(f, f.webkitRelativePath || f.name))
                ev.target.value = ''
            }).catch(() => { ev.target.value = '' })
        },

        /**
         * Cria o documento e anexa o arquivo como primeira versão.
         * São dois passos porque o documento existe antes do arquivo — é o que permite
         * versionar depois (DOC 32).
         */
        criarDocumentoComArquivo (raw, nomeExibido) {
            if (!raw) return

            if (this.ehRede && !this.pastaAtual && !this.instituicaoEnvio) {
                window.eventBus.$emit('alert', {
                    msg: 'Selecione a instituição antes de enviar arquivos na Raiz.', type: 'warning'
                })
                return
            }

            const payload = { titulo: nomeExibido }
            if (this.pastaAtual) payload.pasta_id = this.pastaAtual.id
            else payload.instituicao_id = this.instituicaoAtual()

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.base()}/api/documento/store`, payload, this.auth()).then(r => {
                const form = new FormData()
                form.append('arquivos[]', raw)

                const cfg = Object.assign({}, this.auth())
                cfg.headers = Object.assign({}, cfg.headers, { 'Content-Type': 'multipart/form-data' })

                return this.$axios.post(`${this.base()}/api/documento/versao-enviar/${r.data.id}`, form, cfg)
            }).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Documento enviado.', type: 'success' })
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        limparFiltros () {
            this.filtro = { termo: '', de: '', ate: '', extensao: '', situacao: 'ativo', compartilhados_comigo: false }
            this.paginate.page = 1
            this.carregar()
        },

        alternarSelecao (id) {
            const i = this.selecionados.indexOf(id)
            if (i >= 0) this.selecionados.splice(i, 1)
            else this.selecionados.push(id)
        },

        alternarTodos () {
            this.selecionados = this.todosSelecionados ? [] : this.items.filter(d => !d.deleted_at).map(d => d.id)
        },

        buscarAssinantes (termo) {
            if (!termo || termo.length < 2) return
            this.buscandoAssinante = true
            this.$axios.post(`${this.base()}/api/documento-gestao/transferencia/usuarios`,
                { termo: termo, instituicao_id: this.instituicaoAtual() }, this.auth()).then(r => {
                this.usuariosLote = r.data
                this.buscandoAssinante = false
            }).catch(() => { this.buscandoAssinante = false })
        },

        /** DOC 31 — "envio de documentos em lote para assinaturas". */
        enviarLote () {
            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.base()}/api/documento-assinatura/abrir-lote`, {
                documentos: this.selecionados,
                natureza: this.lote.natureza,
                assinantes: this.lote.assinantes.map(id => ({ user_id: id }))
            }, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)

                let msg = `${r.data.abertos} documento(s) enviado(s) para assinatura.`
                let tipo = 'success'

                if (r.data.falhas.length) {
                    msg += ` ${r.data.falhas.length} ficaram de fora: ` +
                           r.data.falhas.map(f => f.motivo).filter((v, i, a) => a.indexOf(v) === i).join('; ')
                    tipo = 'warning'
                }

                window.eventBus.$emit('alert', { msg: msg, type: tipo })
                this.dialogLote = false
                this.selecionados = []
                this.lote = { natureza: '', assinantes: [] }
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        abrirCompartilhar (tipo, item) {
            this.alvoCompartilhar = {
                tipo: tipo,
                id: item.id,
                nome: tipo === 'pasta' ? item.nome : item.titulo,
                publico: !!item.publico
            }
            this.dialogCompartilhar = true
        },

        getPagePagination (page) { this.paginate.page = page; this.carregar() }
    },
    components: { compartilhamento }
}
</script>
<style scoped>
.rotulo-filtro {
    display: block;
    font-size: 12px;
    color: #909399;
    line-height: 1;
    margin-bottom: 2px;
}

.caminho-atual {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
    font-size: 13px;
    background: #F5F7FA;
    border: 1px solid #EBEEF5;
    border-radius: 16px;
    padding: 5px 14px;
    max-width: 100%;
}
.caminho-icone { color: #909399; margin-right: 6px; font-size: 15px; }
.caminho-sep   { color: #C0C4CC; font-size: 12px; margin: 0 2px; }
.caminho-link {
    color: #606266;
    text-decoration: none;
    padding: 1px 5px;
    border-radius: 4px;
    transition: background .15s, color .15s;
}
.caminho-link:hover { color: #409EFF; background: #ECF5FF; }
.caminho-aqui { color: #303133; font-weight: 600; padding: 1px 5px; }
.descricao-doc { font-size: 12px; color: #909399; }
.area-arrastar >>> .el-upload, .area-arrastar >>> .el-upload-dragger { width: 100%; }
.area-arrastar >>> .el-upload-dragger { height: 110px; }
.card-item {
    border: 1px solid #EBEEF5; border-radius: 4px; padding: 18px 8px; margin-bottom: 10px;
    text-align: center; cursor: pointer; transition: box-shadow .2s;
}
.card-item:hover { box-shadow: 0 2px 12px rgba(0,0,0,.1); }
.card-icone { font-size: 34px; display: block; margin-bottom: 8px; }
.card-nome { font-size: 12px; word-break: break-word; }
.barra-lote { background: #ecf5ff; border: 1px solid #d9ecff; border-radius: 4px; padding: 8px 12px; }
.meta { font-size: 12px; color: #909399; }
</style>
